import React, { useState, useEffect } from "react";
import { Card, Button, Checkbox, Form, Icon, Input, InputNumber, Select, Spin, message } from "antd";
import CKEditor from 'ckeditor4-react';
import ItemFormHelper from "./../itemForm/ItemFormHelper";
import { CheckCircleTwoTone } from '@ant-design/icons';

const ContentSection = ({ form, editFormContents }) => {
    const { getFieldDecorator, validateFields, setFieldsValue } = form;

    const [contentCount, setContentCount] = useState([]);
    const [contentData, setContentData] = useState([]);

    useEffect(() => {
        let count = 0;
        editFormContents.map((item, index) => {
            if (item?.type == "html") {
                contentCount.push("");
                const updateContentCount = [...contentCount];
                setContentCount(updateContentCount);

                _renderContentSection(count);

                setFieldsValue({
                    [`sort${count}`]: item?.sort,
                    [`content${count}`]: item?.content
                });

                count++;
            }
        })

    }, [editFormContents?.length]);

    // BannerState Setter Start
    ItemFormHelper.setContentState({
        content: contentData
    });
    // BannerState Setter End

    const pick = (obj, arr) =>
        arr.reduce((acc, record) => (record in obj && (acc[record] = obj[record]), acc), {});

    const handleSubmit = e => {

        e.preventDefault();
        validateFields((err, values) => {
            if (!err) {
                console.log("Received values of form: ", values);
                let contents = [];
                var size = Object.keys(values).length / 2;
                for (let i = 0; i < size; i++) {
                    let res = pick(values, [`content${i}`, `sort${i}`]);
                    contents.push({
                        type: "html",
                        content: res[`content${i}`],
                        sort: res[`sort${i}`]
                    });
                }

                setContentData(contents);
            }
        });
    };

    const _renderContentSection = (i) => {
        return (
            <>
                <Form.Item {...formItemLayout} label="Sort No">
                    {getFieldDecorator(`sort${i}`, {
                        rules: [{
                            required: true,
                            message: 'Required!'
                        }]
                    })(
                        <InputNumber />
                    )}
                </Form.Item>
                <Form.Item
                    {...formItemLayout}
                    labelAlign="left"
                    label={<span><span style={{ color: "red" }}>*</span>Content</span>}
                >
                    {getFieldDecorator(`content${i}`, {
                        valuePropName: 'data',
                        getValueFromEvent: (event, editor) => {
                            const data = event.editor.getData();
                            return data;
                        },
                        rules: [{
                            required: true,
                            message: 'Required!'
                        }]
                    })(
                        <CKEditor
                            config={{
                                extraPlugins: "colorbutton",
                                removePlugins: 'horizontalrule,blockquote,sourcearea,pasteFromWord',
                                removeButtons:
                                    "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                            }}
                        />
                    )}

                </Form.Item>
            </>
        );
    }

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
        },
    };

    return (
        <div>
            <div className="ant-row hd-title gx-m-0">
                <div className="ant-col-md-12">
                    <h1>Manage Content</h1>
                </div>
                <div className="ant-col-md-12 rite-btn">
                    <Button
                        type="primary"
                        className="color-white"
                        onClick={() => {
                            contentCount.push("");
                            const updateContentCount = [...contentCount];
                            setContentCount(updateContentCount);
                        }}
                    >
                        <i class="icon icon-add"></i> Add
            </Button>
                </div>
            </div>


            <Form onSubmit={handleSubmit} layout="vertical">
                {
                    contentCount?.map((item, index) => {
                        return _renderContentSection(index);
                    })
                }


                <div className="ant-col-md-12">
                    <CheckCircleTwoTone type="primary" onClick={handleSubmit} twoToneColor="#52c41a" style={{ fontSize: '30px', color: '#00000', }} />
                </div>

            </Form>

        </div>
    );

}

export default Form.create()(ContentSection);